import { SelectOption } from '@globaleris/ui.library'
import { ListItem, Typography } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface TemplateListItemPageProps {
  templates: SelectOption[]
  title: string
}

export const TemplateListItem: React.FC<TemplateListItemPageProps> = ({ templates, title }) => {
  const [t] = useTranslation(['globalerisLibrary', 'productsEdit', 'enums'])

  return (
    <ListItem divider disableGutters>
      <Typography variant="caption">{title}</Typography>
      {templates.map(t => (
        <Typography variant="body2" key={`template${t.value}`}>
          {t.label}
        </Typography>
      ))}
    </ListItem>
  )
}
